import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { intlMessage } from 'constants/propTypes';

import './SmartRateTopicCard.scss';

const { block, element } = bem('smart-rate-topic-card');

const SmartRateTopicCard = ({
  description,
  icon,
  iconModifier,
  isSelected,
  onSelect,
  panelId,
  showLess,
  showMore,
  tabId,
  title,
  topicId,
}) => (
  <button
    aria-controls={panelId}
    aria-selected={isSelected}
    className={block({ 'is-selected': isSelected })}
    id={tabId}
    onClick={() => onSelect(topicId)}
    role="tab"
    type="button">
    <Isvg aria-hidden className={element('icon', iconModifier && { [iconModifier]: true })} src={icon} />
    <div className={element('content')}>
      <Message as="h3" className={element('title')} message={title} />
      <Message as="p" className={element('description')} message={description} />
    </div>
    <span className={element('learn-more')}>
      <Message as="span" className={element('learn-more-text')} message={isSelected ? showLess : showMore} />
      <Isvg aria-hidden className={element('learn-more-icon')} src={ICONS.chevronRightThin} />
    </span>
  </button>
);

SmartRateTopicCard.propTypes = {
  description: intlMessage.isRequired,
  icon: PropTypes.string.isRequired,
  iconModifier: PropTypes.string,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  panelId: PropTypes.string.isRequired,
  showLess: intlMessage.isRequired,
  showMore: intlMessage.isRequired,
  tabId: PropTypes.string.isRequired,
  title: intlMessage.isRequired,
  topicId: PropTypes.string.isRequired,
};

export default SmartRateTopicCard;
